import { PersonFormState, Role } from 'shared/data/walletsKyc/v1';
import { z } from 'zod';

import { verifiedDirectorOwnerRequiredError } from './constants';
import { messages } from './messages';

export const personSchema = z.object({
    personId: z.string(),
    userId: z.string().nullable(),
    roles: z.array(z.nativeEnum(Role)),
    firstName: z.string(),
    middleName: z.string().nullish(),
    lastName: z.string(),
    verifyNeeded: z.boolean(),
    isWalletOwner: z.boolean(),
    personFormState: z.nativeEnum(PersonFormState),
    submittedAt: z.string().nullable(),
});

const peopleSchema = z
    .object({
        persons: z.array(personSchema, {
            invalid_type_error: messages.requiredField,
            required_error: messages.requiredField,
        }),
    })
    .superRefine((values, ctx) => {
        if (!values.persons.some((person) => person.roles.includes(Role.director))) {
            ctx.addIssue({
                path: ['persons'],
                message: verifiedDirectorOwnerRequiredError,
                code: z.ZodIssueCode.custom,
            });
        }
    });

export const schema = z
    .object({
        people: peopleSchema,
    })
    .passthrough();
